<template>
    <div class="home">
        <div class="progress">
          <img src="../img/m/progress.png" alt="" />
        </div>
        <div class="award-list">
          <div class="first-award-con ">
            <img src="../img/prize/prize_1.png" alt="" class="awardType" />
            <swiper ref="mySwiper_1" :options="swiperOptions_1" class="first-award" v-if="awardList">
              <swiper-slide
                v-for="item in awardList[0]"
                :key="item.works_id"
                >
                <div class="container" @click="toDetail(item)">
                  <el-image
                    :src="'https://collection2021-cos.chineseplus.net/'+item.video_cover"
                    class="cover"
                    fit="cover"></el-image>
                  <div class="wrapper">
                    
                    <div class="type" :class="{'pic': item.type == 2}">
                      <span v-html="item.type==1?'视频': '图片故事'" ></span>
                    </div>
                    <div class="info">
                      <div class="title">
                        {{item.works_title}}
                      </div>
                      <div class="author">
                        提供者：{{item.realname}}
                      </div>
                      <div class="author">
                        所在国：{{item.cn}}
                      </div>
                      <div class="desc">
                        {{item.desc}}
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-next" slot="button-next"></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
            </swiper>
            <swiper class="mySwiper_1_1 gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs" v-if="awardList">
              <swiper-slide
                v-for="item in awardList[0]"
                :key="item.works_id"
                >
                <div class="container">
                  <el-image
                    :src="'https://collection2021-cos.chineseplus.net/'+item.video_cover"
                    class="cover"
                    fit="cover"></el-image>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="second-award-con link">
            <img src="../img/prize/prize_2.png" alt="" class="awardType" />
            <swiper ref="mySwiper_2" :options="swiperOptions_1" class="second-award" v-if="awardList[1]">
              <swiper-slide
                v-for="(item,index) in secondAward"
                :key="index"
                >
                <div class="container" >
                  <div class="left">
                    <div class="leftWrapper" @click="toDetail(item[0])">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item[0].video_cover"
                        class="cover"
                        
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item[0].type == 2}">
                          <span v-html="item[0].type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item[0].works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item[0].realname}}
                          </div>
                          <div class="author">
                            所在国：{{item[0].cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="right">
                    <div class="rightWrapper" @click="toDetail(item[1])">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item[1].video_cover"
                        class="cover"
                        
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item[1].type == 2}">
                          <span v-html="item[1].type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item[1].works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item[1].realname}}
                          </div>
                          <div class="author">
                            所在国：{{item[1].cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightWrapper" @click="toDetail(item[2])">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item[2].video_cover"
                        class="cover"
                        
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item[2].type == 2}">
                          <span v-html="item[2].type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item[2].works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item[2].realname}}
                          </div>
                          <div class="author">
                            所在国：{{item[2].cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightWrapper" @click="toDetail(item[3])">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item[3].video_cover"
                        class="cover"
                        
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item[3].type == 2}">
                          <span v-html="item[3].type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item[3].works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item[3].realname}}
                          </div>
                          <div class="author">
                            所在国：{{item[3].cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightWrapper" @click="toDetail(item[4])">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item[4].video_cover"
                        class="cover"
                        
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item[3].type == 2}">
                          <span v-html="item[4].type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item[4].works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item[4].realname}}
                          </div>
                          <div class="author">
                            所在国：{{item[4].cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-next" slot="button-next"></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
            </swiper>
          </div>
          <div class="second-award-con third-award-con link">
            <img src="../img/prize/prize_3.png" alt="" class="awardType" />
            <swiper ref="mySwiper_3" :options="swiperOptions_1" class="second-award" v-if="awardList[2]">
              <swiper-slide
                v-for="(item,index) in thirdAward"
                :key="index"
                >
                <div class="container">
                  <div class="left">
                    <div class="leftWrapper" @click="toDetail(item[0])">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item[0].video_cover"
                        class="cover"
                        
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item[0].type == 2}">
                          <span v-html="item[0].type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item[0].works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item[0].realname}}
                          </div>
                          <div class="author">
                            所在国：{{item[0].cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="right">
                    <div class="rightWrapper" @click="toDetail(item[1])">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item[1].video_cover"
                        class="cover"
                        
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item[1].type == 2}">
                          <span v-html="item[1].type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item[1].works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item[1].realname}}
                          </div>
                          <div class="author">
                            所在国：{{item[1].cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightWrapper" @click="toDetail(item[2])">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item[2].video_cover"
                        class="cover"
                        
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item[2].type == 2}">
                          <span v-html="item[2].type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item[2].works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item[2].realname}}
                          </div>
                          <div class="author">
                            所在国：{{item[2].cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightWrapper" @click="toDetail(item[3])">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item[3].video_cover"
                        class="cover"
                        
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item[3].type == 2}">
                          <span v-html="item[3].type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item[3].works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item[3].realname}}
                          </div>
                          <div class="author">
                            所在国：{{item[3].cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightWrapper" @click="toDetail(item[4])">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item[4].video_cover"
                        class="cover"
                        
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item[3].type == 2}">
                          <span v-html="item[4].type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item[4].works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item[4].realname}}
                          </div>
                          <div class="author">
                            所在国：{{item[4].cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="right line_2">
                    <div class="rightWrapper" @click="toDetail(item[5])">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item[5].video_cover"
                        class="cover"
                        
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item[5].type == 2}">
                          <span v-html="item[5].type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item[5].works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item[5].realname}}
                          </div>
                          <div class="author">
                            所在国：{{item[5].cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightWrapper" @click="toDetail(item[6])">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item[6].video_cover"
                        class="cover"
                        
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item[6].type == 2}">
                          <span v-html="item[6].type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item[6].works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item[6].realname}}
                          </div>
                          <div class="author">
                            所在国：{{item[6].cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightWrapper" @click="toDetail(item[7])">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item[7].video_cover"
                        class="cover"
                        
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item[7].type == 2}">
                          <span v-html="item[3].type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item[7].works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item[7].realname}}
                          </div>
                          <div class="author">
                            所在国：{{item[7].cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightWrapper" @click="toDetail(item[8])">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item[8].video_cover"
                        class="cover"
                        
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item[3].type == 2}">
                          <span v-html="item[8].type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item[8].works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item[8].realname}}
                          </div>
                          <div class="author">
                            所在国：{{item[8].cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="left">
                    <div class="leftWrapper" @click="toDetail(item[9])">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item[9].video_cover"
                        class="cover"
                        
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item[9].type == 2}">
                          <span v-html="item[9].type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item[9].works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item[9].realname}}
                          </div>
                          <div class="author">
                            所在国：{{item[9].cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-next" slot="button-next"></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
            </swiper>
          </div>
          <div class="second-award-con fourth-award-con link">
            <img src="../img/prize/prize_4.png" alt="" class="awardType" />
            <swiper ref="mySwiper_4" :options="swiperOptions_1" class="second-award" v-if="awardList[3]">
              <swiper-slide
                v-for="(item,index) in fourthAward"
                :key="index"
                >
                <div class="container">
                  <div class="right">
                    <div class="rightWrapper" v-for="item_1 in item" :key="item_1.certificate_id" @click="toDetail(item_1)">
                      <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item_1.video_cover"
                        class="cover"
                        
                        v-if="item_1.type==1"
                        fit="cover"></el-image>
                        <el-image
                        :src="'https://collection2021-cos.chineseplus.net/'+item_1.cover"
                        class="cover"
                        
                        v-else
                        fit="cover"></el-image>
                      <div class="wrapper">
                        
                        <div class="type" :class="{'pic': item_1.type == 2}">
                          <span v-html="item_1.type==1?'视频': '图片故事'" ></span>
                        </div>
                        <div class="info">
                          <div class="title">
                            {{item_1.works_title}}
                          </div>
                          <div class="author">
                            提供者：{{item_1.realname}}
                          </div>
                          <div class="author">
                            所在国：{{item_1.cn}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-next" slot="button-next"></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
            </swiper>
          </div>
          <div class="second-award-con popular link">
            <img src="../img/prize/prize_5.png" alt="" class="awardType" />
            <div class="popularCon" v-if="awardList&&awardList[4]">
              <div class="container" @click="toDetail(awardList[4][0])">
              <el-image
                :src="'https://collection2021-cos.chineseplus.net/'+awardList[4][0].video_cover"
                class="cover"
                
                fit="cover"></el-image>
              <div class="wrapper">
                
                <div class="type" :class="{'pic': awardList[4][0].type == 2}">
                  <span v-html="awardList[4][0].type==1?'视频': '图片故事'" ></span>
                </div>
                <div class="info">
                  <div class="title">
                    {{awardList[4][0].works_title}}
                  </div>
                  <div class="author">
                    提供者：{{awardList[4][0].realname}}
                  </div>
                  <div class="author">
                    所在国：{{awardList[4][0].cn}}
                  </div>
                  <!-- <div class="desc">
                    {{awardList[4][0].desc}}
                  </div> -->
                </div>
              </div>
            </div>
            <div class="container" @click="toDetail(awardList[4][1])">
              <el-image
                :src="'https://collection2021-cos.chineseplus.net/'+awardList[4][1].video_cover"
                class="cover"
                
                v-if="awardList[4][1].type == 1"
                fit="cover"></el-image>
                <el-image
                :src="'https://collection2021-cos.chineseplus.net/'+awardList[4][1].cover"
                class="cover"
                v-else
                fit="cover"></el-image>
              <div class="wrapper">
                
                <div class="type" :class="{'pic': awardList[4][1].type == 2}">
                  <span v-html="awardList[4][1].type==1?'视频': '图片故事'" ></span>
                </div>
                <div class="info">
                  <div class="title">
                    {{awardList[4][1].works_title}}
                  </div>
                  <div class="author">
                    提供者：{{awardList[4][1].realname}}
                  </div>
                  <div class="author">
                    所在国：{{awardList[4][1].cn}}
                  </div>
                  <!-- <div class="desc">
                    {{awardList[4][1].desc}}
                  </div> -->
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'home',
    data: function () {
        return {
          awardList: [],
          secondAwardList: [],
          swiperOptions_1: {
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }
          },
          swiperOptionThumbs: {
            loopedSlides: 1, // looped slides should be the same
            spaceBetween: 8,
            centeredSlides: true,
            slidesPerView: '1',
            // touchRatio: 0.2,
            slideToClickedSlide: true
          }
        }
    },
    computed: {
      mySwiper_1() {
        return this.$refs.mySwiper_1.swiper
      },
      mySwiper_1_1() {
        return this.$refs.swiperThumbs.swiper
      },
      secondAward() {
        var result = [];
        for(var i=0,len=this.awardList[1].length;i<len;i+=5){
          result.push(this.awardList[1].slice(i,i+5));
        }
        console.log(result)
        return result
      },
      thirdAward() {
        var result = [];
        for(var i=0,len=this.awardList[2].length;i<len;i+=10){
          result.push(this.awardList[2].slice(i,i+10));
        }
        console.log(result)
        return result
      },
      fourthAward() {
        var result = [];
        for(var i=0,len=this.awardList[3].length;i<len;i+=8){
          result.push(this.awardList[3].slice(i,i+8));
        }
        console.log(result)
        return result
      },
    },
    created() {
      this.getAwardList()
    },
    methods: {
      routerTo(path) {
        this.$router.push(path)
      },
      toDetail(detail) {
        var url = 'vlogdetail'
        if(detail.type == 2) {
          url = 'plogdetail'
        }
        this.$router.push({
          path: url,
          query: {
            id: detail.works_id
          }
        })
      },
      getAwardList() {
        this.$utils.get('/works/get-cert-list').then(res => {
          this.awardList = res.data
          this.secondAwardList = res.data[1]
          this.$nextTick(() => {
            const swiperTop = this.mySwiper_1
            const swiperThumbs = this.mySwiper_1_1
            swiperTop.controller.control = swiperThumbs
            swiperThumbs.controller.control = swiperTop
          })

        })
      },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
    width: 100%;
    height: 100%;
    font-size: 24px;
    text-align: center;
    
    .startCon {
      margin-top: 30px;
      cursor: pointer;
    }
    .progress {
      width: 1200px;
      margin: 30px auto;
      img {
        width: 100%;
      }
    }
    .award-list {
      width: 1200px;
      margin: 30px auto;
      .swiper-button-next {
        position: absolute;
      }
      .awardType {
        margin-bottom: 30px;
      }
      .first-award-con {
        width: 100%;
        background-color: rgba(#fff,0.8);
        padding: 30px 0;
        .first-award {
          width: 1074px;
          overflow: hidden;
          margin: auto;
          position: relative;
          --swiper-navigation-color: #7285f8;
          .container {
            width: 920px;
            height: 517px;
            margin: auto;
            position: relative;
            cursor: pointer;
            &:hover {
              .wrapper {
                display: block;
              }
            }
            .wrapper {
              display: none;
              position: absolute;
              top: 0;
              left: 0;
              width: 920px;
              height: 517px;
              margin: auto;
              background-color: rgba(0,0,0,0.3);
              .info {
                position: absolute;
                bottom: 30px;
                margin-left: 12px;
                color: #ffffff;
                text-align: left;
                .title {
                  font-family: MicrosoftYaHei-Bold;
                  font-size: 30px;
                  font-weight: normal;
                  font-stretch: normal;
                  letter-spacing: 0px;
                  margin-bottom: 15px;
                  width: 80%;
                }
                .author {
                  margin-top: 5px;
                  font-size: 12px;
                }
                .desc {
                  margin-top: 15px;
                  font-size: 12px;
                  line-height: 1.4;
                  width: 85%;
                }
              }
            }
            .type {
              position: absolute;
              left: 0;
              top: 0;
              width: 48px;
              height: 26px;
              background-color: #ff418d;
              border-radius: 0px 10px 10px 10px;
              font-size: 16px;
              line-height: 26px;
              color: #fff;
              &.pic {
                width: 80px;
                height: 26px;
                background-color: #3236ce;
                border-radius: 0px 10px 10px 10px;
              }
            }
          }
          .cover {
            // position: absolute;
            // top: 0;
            // left: 0;
            margin: auto;
            width: 920px;
            height: 517px;
          }
        }
        .mySwiper_1_1 {
          // width: 1074px;
          width: 160px;
          // overflow: hidden;
          margin: 8px auto;
          position: relative;
          .swiper-slide {
            overflow: hidden;
            opacity: 0.4;
            border: solid 3px transparent;
          }
          .container {
            width: 160px;
            height: 90px;
            text-align: center;
            cursor: pointer;
            // width: 100%;
          }
          .cover {
            width: 160px;
            height: 90px;
            
            // border: solid 3px #c73b35;
          }
          .swiper-slide-active {
            opacity: 1;
            border: solid 3px #c73b35;
            box-sizing: border-box;
          }
        }
        
      }
      .second-award-con {
        width: 100%;
        background-color: rgba(#fff,0.8);
        padding: 30px 0;
        .second-award {
          width: 1074px;
          overflow: hidden;
          margin: auto;
          position: relative;
          --swiper-navigation-color: #7285f8;
          .container {
            width: 933px;
            height: 345px;
            margin: auto;
            text-align: left;
            position: relative;
            cursor: pointer;
            .wrapper {
              display: none;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              // width: 920px;
              // height: 517px;
              margin: auto;
              background-color: rgba(0,0,0,0.3);
              .info {
                position: absolute;
                bottom: 30px;
                margin-left: 12px;
                color: #ffffff;
                text-align: left;
                .title {
                  font-family: MicrosoftYaHei-Bold;
                  font-size: 18px;
                  font-weight: normal;
                  font-stretch: normal;
                  letter-spacing: 0px;
                  margin-bottom: 15px;
                  width: 100%;
                }
                .author {
                  margin-top: 5px;
                  font-size: 12px;
                }
                .desc {
                  margin-top: 15px;
                  font-size: 12px;
                  line-height: 1.4;
                  width: 85%;
                }
              }
            }
            .type {
              position: absolute;
              left: 0;
              top: 0;
              width: 48px;
              height: 26px;
              text-align: center;
              background-color: #ff418d;
              border-radius: 0px 10px 10px 10px;
              font-size: 16px;
              line-height: 26px;
              color: #fff;
              &.pic {
                width: 80px;
                height: 26px;
                background-color: #3236ce;
                border-radius: 0px 10px 10px 10px;
              }
            }
            .left {
              position: relative;
              display: inline-block;
              width: 456px;
              height: 345px;
              // background-color: #000000;
              border: solid 1px rgba(0, 0, 0, 0.1);
              .leftWrapper {
                width: 100%;
                height: 100%;
                .cover {
                  // position: absolute;
                  // top: 0;
                  // left: 0;
                  margin: auto;
                  width: 100%;
                  height: 100%;
                }
                &:hover {
                  .wrapper {
                    display: block;
                  }
                }
              }
              
            }
            .right {
              
              display: inline-block;
              vertical-align: top;
              width: 461px;
	            height: 345px;
              
              // background-color: #000000;
              // border: solid 1px rgba(0, 0, 0, 0.1);
              .rightWrapper {
                width: 227px;
                height: 171px;
                display: inline-block;
                position: relative;
                margin-left: 3px;
                &:hover {
                  .wrapper {
                    display: block;
                  }
                }
              }
              .cover {
                // position: absolute;
                // top: 0;
                // left: 0;
                margin: auto;
                width: 100%;
                height: 100%;
              }
            }
            .line_2 {
              .rightWrapper {
                margin-left: 0;
                margin-right: 3px;
              }
            }
            
          }
          
        }
      }
      .third-award-con {
        .second-award {
          .container {
            height: 727px;
          }
        }
        
      }
      .fourth-award-con {
        .second-award {
          .container {
            
            .right {
              width: 1024px;
            }
          }
        }
      }
      .popular {
        .popularCon {

        }
        .container {
          width: 448px;
          height: 224px;
          margin: auto;
          position: relative;
          display: inline-block;
          margin: 0 3px;
          cursor: pointer;
          &:hover {
            .wrapper {
              display: block;
            }
          }
          .cover {
            width: 100%;
            height: 100%;
          }
          .wrapper {
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            width: 448px;
            height: 224px;
            margin: auto;
            background-color: rgba(0,0,0,0.3);
            .info {
              position: absolute;
              bottom: 30px;
              margin-left: 12px;
              color: #ffffff;
              text-align: left;
              .title {
                font-family: MicrosoftYaHei-Bold;
                font-size: 30px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                margin-bottom: 15px;
                width: 80%;
              }
              .author {
                margin-top: 5px;
                font-size: 12px;
              }
              .desc {
                margin-top: 15px;
                font-size: 12px;
                line-height: 1.4;
                width: 85%;
              }
            }
          }
          .type {
            position: absolute;
            left: 0;
            top: 0;
            width: 48px;
            height: 26px;
            background-color: #ff418d;
            border-radius: 0px 10px 10px 10px;
            font-size: 16px;
            line-height: 26px;
            color: #fff;
            &.pic {
              width: 80px;
              height: 26px;
              background-color: #3236ce;
              border-radius: 0px 10px 10px 10px;
            }
          }
        }
      }
      .link {
        position: relative;
        margin-top: 65px;
        &:before {
          content: '';
          position: absolute;
          left: 58px;
          top: -88px;
          background-image: url(../img/link.png);
          background-repeat: no-repeat;
          background-size: 100%;
          width: 22px;
          height: 110px;
        }
        &:after {
          content: '';
          position: absolute;
          right: 58px;
          top: -88px;
          background-image: url(../img/link.png);
          background-repeat: no-repeat;
          background-size: 100%;
          width: 22px;
          height: 110px;
        }
      }
    }
}
</style>
